module.exports = {
      id: "white-fb-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "svg-sprite-147fd1e4cc1faf335e98b31c6ae31fe2.svg#white-fb",
      toString: function () {
        return this.url;
      }
    }